import { styled } from '@mui/material/styles';
import ListItemText from '@mui/material/ListItemText';
import { ReactComponent as LogoutIcon } from '#static/media/logout-icon.svg';

export const SideListContainer = styled('div')({
  transition: 'width 0.3s'
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0 4px 0 8px',
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end'
}));

export const StyledLogoutIcon = styled(LogoutIcon)({
  fill: 'currentColor'
});

export const TrailListContainer = styled('div')(({ theme }) => ({
  '& .MuiListItem-root': {
    paddingLeft: 72
  },
  '& .MuiTypography-root': {
    fontSize: '0.9rem'
  },
  [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
    width: 230,
    position: 'fixed',
    top: 218,
    backgroundColor: '#fff',
    border: '1px solid #0000001f',
    '& .MuiListItem-root': {
      paddingLeft: 24
    },
    '& .MuiTypography-root': {
      fontSize: '1rem'
    }
  }
}));

export const StyledListItemText = styled(ListItemText)({
  '& span': {
    minWidth: 100
  }
});
